import { Grid, TextField } from '@material-ui/core';
import React, { ChangeEvent, Fragment } from 'react'
import contentMessages from "src/pages/content/messages";
import { useIntl } from 'react-intl';
import { Controller } from 'react-hook-form';
import useContentFilterStyles from '../../styles';
import MultiSelectField from 'src/components/MultiSelectField';
import { SortByOptions } from 'src/pages/content/contentFilterConfig';


function FilterFieldPrice({
  disabled,
  control,
  register,
  preSetValues,
  handleFilterChangeSwitch
}: {
  disabled: boolean;
  control: any;
  register: any;
  preSetValues: () => void;
  handleFilterChangeSwitch: (onChange: (v: any) => void) => (value: any) => void

}) {
  const { formatMessage } = useIntl();
  const classes = useContentFilterStyles();
  const handleChangeNumeric = (e: ChangeEvent<HTMLInputElement>) => {
    const numCast = Number(e.target.value);
    e.target.value = String(numCast === 0 ? "" : numCast || "");
    preSetValues();
  };

  return (
    <Fragment>
      <Grid item xs={12} md={4} lg={3}>
        <TextField
          label={formatMessage(contentMessages.marketplaceMinPrice)}
          placeholder={formatMessage(contentMessages.marketplaceMinPrice)}
          name="marketplaceMinPrice"
          fullWidth
          className={classes.fGrow1MTop10}
          inputRef={register({
            pattern: {
              value: /^\d*\.?\d*$/,
              message: "Please enter a valid number",
            },
          })}
          onChange={handleChangeNumeric}
        />
      </Grid>
      <Grid item xs={12} md={4} lg={3}>
        <TextField
          label={formatMessage(contentMessages.marketplaceMaxPrice)}
          placeholder={formatMessage(contentMessages.marketplaceMaxPrice)}
          name="marketplaceMaxPrice"
          fullWidth
          className={classes.fGrow1MTop10}
          onChange={handleChangeNumeric}
          inputRef={register({
            pattern: {
              value: /^\d*\.?\d*$/,
              message: "Please enter a valid number",
            },
          })}
        />
      </Grid>
      <Grid item xs={12} md={4} lg={3}>
        <Controller
          name={"sortContent"}
          control={control}
          render={({ onChange, value }) => {
            return (
              <MultiSelectField
                label={formatMessage(contentMessages.marketplaceSortByPrice)}
                options={SortByOptions}
                value={value ? value : ["asc"]}
                onChange={handleFilterChangeSwitch(onChange)}
                disabled={disabled}
                isMultiple={false}
              />
            );
          }}
        />
      </Grid>
    </Fragment>)
}
export default FilterFieldPrice
